import React from 'react'

function OneBlog({service}) {
    const{Image, Title, Link, Fees, Location,Details, Date, Application} = service;
    console.log('service', service);
  return (
    <div>
         <div style={{alignItems:'center',borderRadius:'5px',overflow:'scroll',height:'400px'}}  className="card  bg-base-100 shadow-xl">
                <img src={Image} style={{height:'200px', width:'100%',objectFit:'cover'}} alt="Album"/>
            
                <div className="card-body">
                  <h2 style={{fontFamily:'raleway'}} className="card-title">{Title}</h2> 
                  {Link &&
                  <p style={{fontFamily:'raleway'}} className='text-sm'>relevant link: <span style={{color:'#0E4C92',fontWeight:'600'}}><a href={service.Link} target="_blank" rel="noopener noreferrer">
                    {Link}</a></span></p>
                   }
                   {Fees &&
                  <p style={{fontFamily:'raleway'}} className='text-sm'>Exam Fees: <span style={{fontWeight:"bold"}}>{Fees}</span></p>
                   }
                  {Application &&
                  <p style={{fontFamily:'raleway'}} className='text-sm'>Application Deadline: <span style={{fontWeight:"bold"}}>{Application}</span></p>
                  }
                  {Location &&
                  <p style={{fontFamily:'raleway'}} className='text-sm'>Location:  <span style={{fontWeight:"bold"}}>{Location}</span></p>
                  }
                  {Details &&
                  <p style={{fontFamily:'raleway'}} className='text-sm'>Detail Info: <span style={{fontWeight:"bold"}}>{Details}</span></p>
                  }
                  <p style={{fontFamily:'raleway'}} className='text-xs'>Posted in <span style={{fontWeight:"bold"}}>{Date}</span></p>
                </div>
            
         </div>
        
    </div>
  )
}

export default OneBlog